/**
 * The one Firebase app for the admin console.
 *
 * **The config below is not a secret and is deliberately in source.** A
 * Firebase web config ships inside the JS bundle no matter where it is kept —
 * an env var is inlined by Vite at build time, so hiding it there buys
 * nothing. Security comes from `firestore.rules`, `storage.rules` and the
 * `requireRole(req, 'admin')` check inside every callable, not from the key
 * being unknown. CLAUDE.md §1's "no hardcoded credentials" is about secrets;
 * this is a public project identifier.
 *
 * The project is `jaagur-app-2026` and the region is `asia-south1`. Both are
 * pinned here rather than defaulted: `getFunctions(app)` with no region
 * silently talks to `us-central1`, where none of these functions exist, and
 * the failure surfaces as a 404 on every call rather than as a config error.
 */
import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

export const REGION = 'asia-south1'

const firebaseConfig = {
  apiKey: 'AIzaSyBGNen4TT8G1dwdTf0cVkP9X58aQV1CZj4',
  authDomain: 'jaagur-app-2026.firebaseapp.com',
  projectId: 'jaagur-app-2026',
  storageBucket: 'jaagur-app-2026.firebasestorage.app',
  messagingSenderId: '772447022933',
  appId: '1:772447022933:web:9c646613fdc2b7b9aec9dc',
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app, REGION)

/**
 * Read-only in practice. `storage.rules` is `allow write: if false` on every
 * path, so this is used for `getDownloadURL` — turning the Storage object
 * paths held in a product’s `image_urls` into something an <img> can fetch.
 * Uploads go through a signed URL minted by `createProductImageUpload`, which
 * bypasses the SDK entirely.
 */
export const storage = getStorage(app)

/**
 * Emulator wiring is **opt-in by flag, never by build mode**.
 *
 * The Flutter app takes the same position (`--dart-define=USE_EMULATOR`), and
 * for the same reason: if this keyed off `import.meta.env.DEV`, a production
 * build would be one bundler misconfiguration away from pointing the live
 * console at localhost — or worse, a local build at production while the
 * developer believed otherwise.
 *
 *   VITE_USE_EMULATOR=true npm run dev
 */
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  connectStorageEmulator(storage, '127.0.0.1', 9199)
}
